module.exports = function getResource(label, vars = []) {
    const resources = {
        checkboxContentDefaultText: 'J’accepte les',
        checkboxContentDefaultLink: 'Modalités'
    };
    return resources[label];
};
